import { render, staticRenderFns } from "./DisputeTable.vue?vue&type=template&id=a364e73e&"
import script from "./DisputeTable.vue?vue&type=script&lang=js&"
export * from "./DisputeTable.vue?vue&type=script&lang=js&"
import style0 from "./DisputeTable.vue?vue&type=style&index=0&id=a364e73e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports